// RoleGuard — компонент для admin-only routes.
// Проверяет наличие requiredRole в currentUser.roles. Иначе → redirect на /403.
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';

interface RoleGuardProps {
  children: ReactNode;
  /** Код роли, требуемой для доступа (например "ADMIN"). */
  requiredRole: string;
}

/** Wrapper для role-based routes. */
export function RoleGuard({ children, requiredRole }: RoleGuardProps): JSX.Element {
  const { currentUser, status } = useAuth();

  if (status !== 'authenticated' || !currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Backend возвращает коды ролей в lowercase ("admin", "user", "department_head").
  // Нормализуем сравнение через toLowerCase() для устойчивости к разным вариантам.
  const target = requiredRole.toLowerCase();
  const hasRole = currentUser.roles.some((r) => r.code.toLowerCase() === target);
  if (!hasRole) {
    return <Navigate to="/403" replace />;
  }

  return <>{children}</>;
}
